import { IconType } from "../../components/components/Icon/interfaces";
import { CustomerActivityModel, CustomerActivityModelExtended } from "../../customer/model/CustomerActivityModel";
import { CommonUtility } from "../../Services/CommonUtility";
import { PolicyIconMapping } from "../tasks-dashboard/TaskSummaryItem";

class ActivityDashboardService {

    public enrichActivityItem = (item : CustomerActivityModel) : CustomerActivityModelExtended => {
        let custAct : CustomerActivityModelExtended  = {...item}
        
        custAct.activityEffDateFormatted = CommonUtility.formateDateTime(custAct.activityEffDate);

        custAct.descriptionFormatted = CommonUtility.truncateString(custAct.description, 50)

        return custAct;
    }

    public getPolicyTypeIcon = (policyTypeId : string) : IconType => {
        let iconType : IconType = null;
        if (policyTypeId) {
            let polTypeIconName = PolicyIconMapping[policyTypeId];   
            if (polTypeIconName) {
                iconType = polTypeIconName as IconType;
            }
        }

        return iconType;
    }
}

export default ActivityDashboardService;